<div class="spinner-overlay" *ngIf="cargando">
  <div class="spinner"></div>
</div>
<div class="container mt-2 mb-5">

    <div class="row">
        <div class="col-12 shadow-lg rounded p-4 fondoNegro">
            <mat-icon class="float-right rounded pb-2 pl-3 pr-3 botonesCerrar" mat-button mat-dialog-close>
                cancel_presentation</mat-icon>
            <div class="centrarTexto">
                <h3 class="colorLetras"><strong>REGÍSTRATE</strong></h3>
                <h5><strong>Compra tus Tickets Premium</strong></h5>
            </div>
            <hr>


            <form (ngSubmit)="!todoForm.invalid && saveUsuario()" class="mt-4" #todoForm="ngForm">


                    <fieldset class="form-group">

                        <input type="text" class="form-control" name="nombre" placeholder="Nombre completo" required
                            minlength="6" pattern="[a-zA-Z\s]+" [(ngModel)]="usuario.nombre" #nombre="ngModel">
                        <ng-container *ngIf="nombre.invalid && (nombre.dirty || nombre.touched)">
                            <small class="colorLetras" *ngIf="nombre.errors.minlength">
                                El nombre debe tener al menos 6 caracteres.
                            </small>
                            <br>
                            <small class="colorLetras" *ngIf="nombre.errors.pattern">
                                El nombre no puede contener números.
                            </small>
                        </ng-container>

                    </fieldset>
                    <fieldset class="form-group">

                    <select class="form-control" name="tipoDocumento" required="required"
                        placeholder="Tipo de documento" [(ngModel)]="usuario.tipo_documento">
                        <option value="" disabled>Tipo de documento</option>
                        <option value="Cedula" selected>Cédula</option>
                        <option value="Tarjeta de identidad">Tarjeta de Identidad</option>
                        <option value="Pasaporte">Pasaporte</option>
                        <option value="Cedula de Extranjería ">Cédula de extranjería</option>
                    </select>
                </fieldset>
                

                <fieldset class="form-group">
                    <input class="form-control " name="id" placeholder="Número de documento" required="required"
                        [(ngModel)]="usuario.numeroDocumento">
                </fieldset>

                <fieldset class="form-group">

                    <input class="form-control" id="bloquear2" name="idconfirmacion"
                        placeholder="Confirmar número de documento" required="required"
                        [(ngModel)]="confimarcionDocumento">
                    <small *ngIf="this.usuario.numeroDocumento!=confimarcionDocumento" class="colorLetras">Verifica el
                        número de documento</small>
                </fieldset>

                <fieldset class="form-group">

                    <input type="text" placeholder="Número de celular" class="form-control " name="celular"
                        required="required" [(ngModel)]="usuario.celular" pattern="^\d+$">

                </fieldset>

                <fieldset class="form-group">

                    <input type="email" placeholder="Correo" class="form-control " id="email" name="correo"
                        required="required" [(ngModel)]="usuario.correo" (input)="validateEmail()" 
                        [readonly]="isGoogleRegistration">
                    <small class="colorLetras">Verifica que hayas escrito bien tu correo, ahí llegarán tus
                        Tickets</small>
                    <small *ngIf="isGoogleRegistration" class="colorLetras">Correo verificado con Google</small>
                </fieldset>

                <fieldset class="form-group">

                    <input type="email" id="bloquear" placeholder="Confirmar correo" class="form-control "
                        name="confirmacorreo" required="required" [(ngModel)]="confimarcionCorreo" 
                        [readonly]="isGoogleRegistration">
                    <small *ngIf="this.usuario.correo!=confimarcionCorreo && !isGoogleRegistration" class="colorLetras">Verifica el
                        correo</small>
                    <small *ngIf="isGoogleRegistration" class="colorLetras">Correo confirmado automáticamente</small>
                </fieldset>


                <fieldset class="form-group position-relative" *ngIf="!isGoogleRegistration">

                    <input 
                    [type]="mostrarPassword ? 'text' : 'password'" 
                    placeholder="Contraseña" 
                    class="form-control pr-5" 
                    name="contrasena"
                    required="required" 
                    [(ngModel)]="usuario.contrasena">

                    <span
                    class="position-absolute end-0 top-50 translate-middle-y me-3"
                    style="cursor: pointer"
                    (click)="togglePassword()">
                        <i [ngClass]="mostrarPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                    </span>
                </fieldset>


                <div class="container-fluid">
                    <div class="row">
                        <fieldset class="form-group pl-4 col-12 col-md-4">
                            <input type="checkbox" class="form-check-input" (change)="publicidad()" id="public"
                                required="required">
                            <small class="form-check-label colorGris" for="public">Acepto que me envíen
                                publicidad</small>
                        </fieldset>

                        <fieldset class="form-group pl-4 col-12 col-md-4">
                            <input type="checkbox" class="form-check-input" (change)="aceptarTerminos()" id="public"
                                required="required">
                            <small class="form-check-label colorGris" for="public">He leído y acepto <a class="terminos"
                                    href="https://codigos.allticketscol.com/TerminosYCondiciones.html"
                                    target="_blank">Términos y Condiciones</a></small>
                        </fieldset>

                        <fieldset class="form-group pl-4 col-12 col-md-4">
                            <input type="checkbox" class="form-check-input" (change)="aceptarTratamiento()" id="public"
                                required="required">
                            <small class="form-check-label colorGris" for="public">He leído y acepto <a class="terminos"
                                    href="https://codigos.allticketscol.com/TratamientoDeDatos.html"
                                    target="_blank">Tratamiento de datos</a> </small>
                        </fieldset>

                    </div>
                </div>




                <div style="text-align: center;">
                    <button class="btn botonLogin mt-2 mb-3" type="submit">Registrarse</button>
                </div>

            </form>
            
            <div class="centrarTexto mb-3" *ngIf="!isGoogleRegistration">
                <span class="colorLetras">O</span>
            </div>
            
            <div style="text-align: center;" *ngIf="!isGoogleRegistration">
                <button class="btn botonRegistroGoogle mt-2 mb-3" (click)="registrarseConGoogle()" type="button">
                    <svg class="me-2" width="20" height="20" viewBox="0 0 24 24">
                        <path fill="#4285f4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                        <path fill="#34a853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                        <path fill="#fbbc05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                        <path fill="#ea4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                    </svg>
                    Registrarse con Google
                </button>
            </div>
        </div>
    </div>
</div>
